export default __webpack_public_path__ + "static/media/Redacted.afc83345.png";